export const SUPPORTED_CHART_ID_MAP = {
  backlog: "backlog"
};
